import React, {Component} from 'react';
import {withRouter} from 'react-router-dom'
import { connect } from 'react-redux'
import penaLogo from '../../../img/cintilloLogo.svg';
import logo from '../../../img/i-strategies-logo.svg'

class Slide extends Component{
	
	location() {
		let text='';

		switch(this.props.location.pathname){
			case '/empleados':
				if(this.props.tipoUsuario=='empresa')
				text = 'Empleados';
			else
				text = 'Conductores';
			break;

			case '/perfiles':
				text = 'Perfiles';
			break;

			case '/empresa':
				text = 'Empresas';
			break;

			case '/vehiculos':
				text = 'Vehículos';
			break;

			case '/usuarios':
				text = 'Usuarios';
			break;

			case '/informacion':
				text = 'Información de la Empresa';
			break;

			case '/reportes':
				text = 'Reportes';
			break;

			case '/tipos_vehiculos':
				text = 'Tipo de Vehículos';
			break;

			case '/nuevoViajeA':
				text = 'Programación';
			break;

			case '/rutas':
				text = 'Rutas';
			break;

			case '/tarifasAvianca':
				text = 'Tarifas Avianca';
			break;

			case '/newRutes':
				text = 'Agregar Rutas';
			break;

			case '/reporte_operacionalA':
				text = 'Reporte Operacional';
			break;
			
			case '/estado_ruta':
				text = 'Estado de Rutas';
			break;

			case '/editar_viaje':
				text = 'Viajes';
			break;

			case '/nuevoViaje':
				text = 'Programación';
			break;

			case '/costos':
				text = 'Costo';
			break;

			case '/':
				text = 'Bienvenido';
			break;
			
			case '/login':
				text = 'Bienvenido';
			break;
		}
		return text
	}

	render(){
		const style = {
			display: 'flex',
			marginTop: '35px',
			marginLeft: '80px',
			fontSize: '23px',
			fontWeight: 'bold',
			fontFamily: 'sans-serif',
			textAling: 'center'
		};	
		return(
			<div className="App-header">
				<div className='row'>
					<div className='col-md-7 col-sm-11'>
						<h1 style={style}>{this.location()}</h1>
					</div>
					<div className='col-md-3 col-sm-11'>
						<img src={logo} style={{ resize: 'contain', padding: '30px'}}/>
					</div>
					<div className='col-md-2 col-sm-1'>
						<img src={penaLogo} style={{ resize: 'contain', width: '3em', marginTop: '0.9em' }} />
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) =>({
	tipoUsuario: state.tipoUsuario
})

export default withRouter(connect(mapStateToProps, null)(Slide))



// WEBPACK FOOTER //
// ./src/Components/Globals/Slide/slide.jsx